export default {
    moves: 'Lépések',
    time: 'Idő',
    score: 'Pontszám',
    settings: 'Beállítások',
    sounds: 'Hang',
    autocomplete: 'Automatikus befejezés',
    leftHanded: 'Balkezes mód',
    newDeal: 'Új leosztás',
    design: 'Személyre szabás',
    easy: 'Könnyű',
    medium: 'Közepes',
    hard: 'Nehéz',
    expert: 'Szakértő',
    master: 'Mester',
    random: 'Random',
    balanced: 'Egyensúly',
    rulesKlondikeURL: 'https://solitaires.com/hu/articles/how-to-play-solitaire/',
    cardHighlight: 'Kártya kiemelés',
    rulesSpiderURL: 'https://solitaires.com/hu/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/hu/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Automatikus játék',
    noMagicNeeded: 'Nincs szükség varázspálcára - folytasd a játékot magad!',
    leaveFeedback: 'Hagyj visszajelzést',
    feedbackThankYou: 'Értékeljük a véleményedet!',
    feedbackError: 'Hiba történt. Az üzenet nem került elküldésre.',
    thanksSubscribing: 'Köszönjük a feliratkozást!',
    rulesPyramidURL: 'https://solitaires.com/hu/articles/how-to-play-pyramid-solitaire/',

    tutorialSkip: 'Kihagyás',
    tutorialRestart: 'Újrakezdés',

    klondikeTutorialStep1: 'A célod, hogy az összes kártyát áthelyezd az alapokra, minden színt Ásztól Királyig növekvő sorrendben — például <span style="color: #F11F1F;">Á♥, 2♥, 3♥</span> és így tovább. Koppints egy kártyára, hogy odaküldd!',
    klondikeTutorialStep2: 'Remek! Folytasd a sorozatok építését az alapokon.',
    klondikeTutorialStep3: 'Szép munka! Mozgathatsz kártyákat az oszlopok között — csak tedd egy olyanra, amely eggyel nagyobb értékű és ellentétes színű.',
    klondikeTutorialStep4: 'Elmozgathatsz egy sorozatot, ha az alsó kártya eggyel kisebb értékű és eltérő színű, mint az a kártya, amelyre helyezed.',
    klondikeTutorialStep5: 'Ha van egy üres oszlop a táblán, oda csak Királyt vagy Királlyal kezdődő sorozatot tehetsz.',
    klondikeTutorialStep6: 'Ha elfogynak a lépéseid, koppints a paklira, hogy új lapokat fordíts fel. Ezeket a táblára vagy az alapokra helyezheted.',
    klondikeTutorialStep7: 'Szuper! Most már egyedül is folytathatod a játékot.',
    klondikeTutorialStep8: 'Ha elfogy a pakli, koppints rá a frissítéshez és folytasd a játékot.',
    klondikeTutorialStep9: 'Majdnem kész vagy! Töltsd fel az alapokat, hogy megnyerd a játékot.',

    spiderTutorialStep1: 'A célod, hogy az összes kártyát áthelyezd az alapra úgy, hogy a táblán csökkenő sorrendben, Királytól Ászig rendezed őket. Koppints egy kártyára, hogy elkezdd építeni a sort!',
    spiderTutorialStep2: 'Akkor mozgathatsz egy sorozatot, ha az alsó kártya eggyel kisebb értékű, mint az, amelyikre ráhelyezed. Koppints az alsóra, hogy az egész sort áthelyezd!',
    spiderTutorialStep3: 'Szép munka! Építsd tovább a sorozatot — ha teljes lesz, automatikusan átkerül az alapra.',
    spiderTutorialStep4: 'Ha nincs több lépésed, koppints a paklira, hogy új kártyákat ossz ki — egyet-egyet minden oszlopba.',
    spiderTutorialStep5: 'Ügyes vagy! Most már rajtad a sor — fejezd be a játékot!',

    freeCellTutorialStep1: 'A célod, hogy az összes kártyát áthelyezd az alapra, minden színt Ásztól Királyig növekvő sorrendben — például A♠, 2♠, 3♠ és így tovább. Koppints egy kártyára, hogy odaküldd!',
    freeCellTutorialStep2: 'Mozgathatsz kártyákat az oszlopok között — csak tedd egy olyanra, amely eggyel nagyobb értékű és eltérő színű.',
    freeCellTutorialStep3: 'Elmozgathatsz egy sorozatot, ha az alsó kártya eggyel kisebb értékű és más színű, mint az a kártya, amelyre helyezed. Ne feledd: nem mozgathatsz több kártyát, mint ahány üres szabad cella van, plusz egy.',
    freeCellTutorialStep4: 'Nagyszerű! Bármelyik egyedi kártyát vagy egy sorozatot elhelyezhetsz egy üres oszlopban a táblán.',
    freeCellTutorialStep5: 'A szabad cellák speciális helyek, ahol ideiglenesen tárolhatsz kártyákat. Mindegyik csak egy kártyát tarthat, amit később visszatehetsz a táblára vagy az alapra.',
    freeCellTutorialStep6: 'Most rajtad a sor! Használd, amit tanultál, és fejezd be a játékot!',

    startTutorialPopupTitle: 'Üdvözlünk! Nézd meg a rövid oktatást, és tanuld meg az alapokat, mielőtt elkezdenéd a játékot.',
    startTutorial: 'Oktatás indítása',
    skipTutorial: 'Kihagyás',
};
